'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function DMFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-6h0dtvn44", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-dd23r7dx7", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-l3c0n90mp" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-l3c0n90mp", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-6h0dtvn44)" }, /* @__PURE__ */ React.createElement("use", { fill: "#279e19", xlinkHref: "#mantine-l3c0n90mp" }), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-dd23r7dx7)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M17 0h2v13h13v2H19v9h-2v-9H0v-2h17z" }), /* @__PURE__ */ React.createElement("path", { fill: "#272727", d: "M15 0h2v11h15v2H17v11h-2V13H0v-2h15z" }), /* @__PURE__ */ React.createElement("path", { fill: "#feca00", d: "M13 0h2v9h17v2H15v13h-2V11H0V9h13z" }), /* @__PURE__ */ React.createElement("circle", { cx: "16", cy: "12", r: "8", fill: "#c51918" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#804bff",
        d: "M14.726 8.413c.253-.822.674-1.02 1.262-.596 1.385.682 1.841 1.465 2.375 2.352.535.887-1.31.237-1.654-.262-.344-.5-2.253-.661-1.983-1.078.18-.277.18-.416 0-.416z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#a95601",
        d: "M14.413 14.725c-.626.857-.626 1.286 0 1.286.94 0 4.75-.277 4.293-.643-.305-.244-1.585-.244-3.841 0z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#804bff",
        d: "M15.818 14.685c-.058-.065-.915-.628-1.25-1.916-.23-.89-.089-2.557.236-2.887.797-.807 1.263-.333 1.263.878s.048 4.224-.249 3.925z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#279e19",
        d: "M15.717 14.054c-.066.63.063 1.312.387 2.047.486 1.103 1.467 1.082 1.467.18 0-.903.716-.056.99.546.276.602-.436-5.348-1.447-6.679-1.01-1.331-1.985-1.417-1.69-.556.195.573.293 2.06.293 4.462z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#feca00",
        d: "M15.127 7.6c-.285.183-.427.526-.427 1.029 0 .503.337.425 1.012-.234z"
      }
    ), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#279e19",
        stroke: "#feca00",
        strokeWidth: ".1",
        d: "M16.89 16.814l-.292.924.779.577-.97.009-.307.919-.308-.92-.969-.008.779-.577-.291-.924.789.562zm2.678-1.383l.308.919.969.008-.78.577.292.924-.79-.562-.788.562.29-.924-.778-.577.97-.008zm-6.936 0l.308.919.969.008-.779.577.291.924-.789-.562-.79.562.292-.924-.779-.577.97-.008zm9.868-2.694l-.29.924.778.577-.969.009-.308.919-.308-.92-.969-.008.78-.577-.292-.924.79.563zm-11.222 0l-.291.924.779.577-.97.009-.307.919-.308-.92-.97-.008.78-.577-.291-.924.789.563zM21.71 8.834l.308.92.969.008-.779.577.291.924-.789-.563-.789.563.291-.924-.779-.577.97-.009zm-11.222 0l.308.92.969.008-.78.577.292.924-.79-.563-.788.563.29-.924-.778-.577.969-.009zm9.868-2.693l-.291.924.779.577-.97.008-.307.92-.308-.92-.969-.008.779-.577-.291-.924.789.562zm-6.936 0l-.291.924.779.577-.97.008-.307.92-.308-.92-.969-.008.78-.577-.292-.924.789.562zm2.68-1.384l.308.92.969.008-.78.577.292.924-.789-.562-.79.562.292-.924-.779-.577.97-.009z"
      }
    ))))
  );
}

export { DMFlag };
//# sourceMappingURL=DM.mjs.map
